import { FORM_AUTH } from 'src/modules/constants';
import { ModulesList } from 'src/modules/types';
import FormAuth from './index';

const module: ModulesList = {
  [FORM_AUTH]: {
    component: FormAuth,
  },
};

export default module;
